import { useQuery } from '@tanstack/vue-query'
import { get } from '@/api/base'
import { HttpStatusCode } from 'axios'
import moment from 'moment/moment'
import { MaybeRef } from '@vueuse/core'
import { computed, unref } from 'vue'
import { JobPredictionResponse } from '@/models/job-prediction'
import { convertToCamelCase } from '@/models/utils/casing'

export function useGetJobAutomationQuery(
  jobNumber: MaybeRef<number | null | undefined>,
  options?: { enabled?: MaybeRef<boolean>; refetchInterval?: number | false },
) {
  const computedJobNumber = computed(() => unref(jobNumber))

  return useQuery({
    queryKey: ['job-automation', computedJobNumber],
    queryFn: async () => {
      const jobNum = computedJobNumber.value

      // Don't make the API call if jobNumber is null or undefined
      if (jobNum == null || jobNum === undefined) {
        return null
      }

      const response = await get<JobPredictionResponse>(`/api/jobs/${jobNum}/automation/details`, {
        headers: { 'Api-Version': '2025-06-01' },
      })
      if (response.status === HttpStatusCode.NoContent) {
        return null
      }
      return convertToCamelCase(response.data)
    },
    enabled:
      options?.enabled ??
      computed(() => computedJobNumber.value != null && computedJobNumber.value !== undefined),
    staleTime: moment.duration(10, 'minutes').asMilliseconds(),
    refetchInterval: options?.refetchInterval,
  })
}
